<template>
  <code-list title="Oblasti" module-name="area"></code-list>
</template>

<script>
  import codeList from 'components/codeListGeneric';

  export default {
    components: {codeList}
  }
</script>



// WEBPACK FOOTER //
// client/views/areas.vue